import { FC, useContext } from 'react'

import { BlockStateEnum } from 'packages/feature-utils/test-paper'
import { PaperBlock } from 'packages/sdks-next/growp'

import { BlockList } from '@/features/test-paper/components/BlockList'

import { EditPaperContext } from '../context'

/**
 * 编辑试卷内容
 *
 * @returns 组件
 */
export const EditContent: FC<{
  blocks: PaperBlock[] | null
}> = ({ blocks }) => {
  const { paper } = useContext(EditPaperContext)

  return (
    <BlockList
      paper={paper}
      blocks={blocks || []}
      blockMovable={true}
      initialState={BlockStateEnum.Display}
      availableStates={[
        BlockStateEnum.Display,
        BlockStateEnum.Editing,
        BlockStateEnum.Selected,
      ]}
    />
  )
}
